<div
  [class]="item().link ? 'hover:bg-interactive' : ''"
  class="relative inline-block items-center rounded-sm px-1 py-0.5">
  <a
    [class]="textClass()"
    [routerLink]="item().link"
    class="block max-w-48 truncate text-[13px]">
    {{ item().label }}
  </a>
</div>
